<template>
  <div>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
            <h5 class="float-left"><i class='fa fa-search'></i> Search</h5>
          </b-card-header>
          <b-card-body>
            <b-form>
              <b-row>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sStartTime">From (yyyy/mm/dd 00:00:00) From</label>
                  <b-input id="sStartTime" type="date" placeholder="" v-model.trim="sStartTime"></b-input>
                </b-col>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sEndTime">To (yyyy/mm/dd 23:59:59) To</label>
                  <b-input id="sEndTime" type="date" placeholder="" v-model.trim="sEndTime"></b-input>
                </b-col>
                <b-col sm="3" class="align-self-end">
                  <b-button id="sBtn" variant="primary" @click="search"><i class="fa fa-search"></i> Search</b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-card no-body>
          <b-card-header>
            <h3 class="float-left"><i class='fa fa-tag'></i> Report</h3>
          </b-card-header>
          <b-card-body>
            <b-row>
              <b-col sm="12" md="6">
                <b-row>
                  <b-col sm="12"><h4>Total Users: {{ stats.totalUser }}</h4></b-col>
                  <b-col sm="12"><h4>Total Unique Users: {{ stats.totalUniqueUser }}</h4></b-col>
                </b-row>
              </b-col>
              <b-col sm="12" md="6">
                <b-row>
                  <b-col sm="12"><h4>Total Purchase: {{ format(stats.totalPurchase, '0,0.00') }}</h4></b-col>
                  <b-col sm="12"><h4>Total Rewards: {{ format(stats.totalReward, '0,0.00') }}</h4></b-col>
                </b-row>
              </b-col>
            </b-row>
            <br/>
            <div class="overflow-auto">
              <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields">
                <template v-slot:cell(TotalPurchase)="data">
                  {{ format(data.item.TotalPurchase, '0,0.00') }}
                </template>
                <template v-slot:cell(TotalReward)="data">
                  {{ format(data.item.TotalReward, '0,0.00') }}
                </template>
              </b-table>
            </div>
            <nav>
              <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Events } from '../../../../events.js'
import VueNotifications from 'vue-notifications'
import numeral from 'numeral'
const moment = require('moment-timezone')

export default {
  name: 'scratchcard-report-table',
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      items: [],
      fields: [
        {key: 'Name', label: 'Name'},
        {key: 'TotalTicket', label: 'Users'},
        {key: 'TotalUniqueUser', label: 'Unique Users'},
        {key: 'TotalPurchase', label: 'Purchase'},
        {key: 'TotalReward', label: 'Rewards'}
      ],
      stats: {
        totalUser: 0,
        totalUniqueUser: 0,
        totalPurchase: 0,
        totalReward: 0
      },
      perPage: 50,
      currentPage: 1,
      sStartTime: moment().subtract(1, 'days').tz('Asia/Taipei').format('YYYY-MM-DD'),
      sEndTime: moment().subtract(1, 'days').tz('Asia/Taipei').format('YYYY-MM-DD')
    }
  },
  methods: {
    format (num, fmt) {
      return numeral(num).format(fmt)
    },
    getRowCount (item) {
      return item.length
    },
    async search () {
      try {
        Events.$emit('loader')
        let queryStr = `start=${this.sStartTime}&end=${this.sEndTime}`
        let { data } = await this.$http.get(this.API_ENDPOINT + '/scratchcard/ticket/report?' + queryStr, { headers: { 'Content-Type': 'application/json' } })
        console.log(data)
        this.items = data.result
        this.stats.totalUser = data.stats.TotalTicket
        this.stats.totalUniqueUser = data.stats.TotalUniqueUser
        this.stats.totalPurchase = data.stats.TotalPurchase
        this.stats.totalReward = data.stats.TotalReward
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    }
  },
  async created () {
    await this.search()
  }
}
</script>


// WEBPACK FOOTER //
// src/views/report/mini-games/scratchcard/ScratchCardReportTable.vue